import React from 'react';

import { Page } from './Page/Page.jsx';

export const PagesList = ({
  mode = 'content',
  pages,
  pageTemplates,
  readonly = false,
  site,
  duplicate,
}) => {
  // map the list of page templates to a lookup
  //
  // {'template_name': 'Template name'}
  const templateNames = pageTemplates
    ? pageTemplates.reduce((prev, cur) => {
        prev[cur.template_name] = cur.name;
        return prev;
      }, {})
    : null;

  return (
    <div className="sb-content-view-row">
      {pages.map((page) => {
        return (
          <Page
            key={page.id}
            business={site.business}
            readonly={readonly}
            site={site}
            page={page}
            templateNames={templateNames}
            mode={mode}
            duplicate={duplicate}
          />
        );
      })}
    </div>
  );
};
